import { type LocationDescriptor } from 'history';

import { api } from 'common';

export function shouldOpenInNewTab(event: React.MouseEvent) {
  return event.ctrlKey || event.metaKey;
}

export function getPathFromLocationDescriptor(locationDescriptor: LocationDescriptor) {
  return typeof locationDescriptor === 'string'
    ? locationDescriptor
    : [locationDescriptor.pathname, locationDescriptor.search].join('?');
}

export function openRouteInNewTab(locationDescriptor: LocationDescriptor) {
  const pathname = getPathFromLocationDescriptor(locationDescriptor);
  window.open(`#${pathname}`, '_blank', 'rel=noopener noreferrer');
}

export function formatSearchResultLink(result: api.Search.Result) {
  switch (result.entity.type) {
    case api.Search.Entity.Encounter:
      return `/entity/encounters/${result.id}`;
    case api.Search.Entity.Order:
      return `/entity/orders/${result.id}`;
    case api.Search.Entity.Patient:
      return `/entity/patients/${result.id}`;
    case api.Search.Entity.ExternalDocumentPacket:
      return `/entity/externalDocumentPackets/${result.id}`;
  }
}
